import { EventSpaceActions } from "@circle-react/components/Spaces/Header/SpaceHeaderActions/EventSpaceActions";
import { useLargeScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";
import type { Space } from "@circle-react/types";
import { Dropdown } from "@circle-react-uikit/Dropdown";
import { LeaveAndDeleteSpaceOptions } from "./LeaveAndDeleteSpaceOptions";
import { ManageSpaceOptions } from "./ManageSpaceOptions";
import { NotificationsOptions } from "./NotificationsOptions";

export interface EventSpaceOptionsProps {
  canMemberManageSpace: boolean;
  isAdmin: boolean;
  isMember: boolean;
  onAddCoverImage?: () => void;
  onInviteMember?: () => void;
  space: Space;
}

export const EventSpaceOptions = ({
  space,
  isAdmin,
  canMemberManageSpace,
  isMember,
  onInviteMember = () => {},
  onAddCoverImage,
}: EventSpaceOptionsProps) => {
  const isLgScreen = useLargeScreenMediaQuery();

  return (
    <>
      {isMember && (
        <div className="md:hidden">
          <EventSpaceActions space={space} />
          <Dropdown.Separator />
        </div>
      )}

      {canMemberManageSpace && (
        <ManageSpaceOptions
          space={space}
          onInviteMember={onInviteMember}
          onAddCoverImage={onAddCoverImage}
        />
      )}

      {((isMember && isLgScreen) || canMemberManageSpace) && (
        <Dropdown.Separator />
      )}

      <NotificationsOptions space={space} />

      <LeaveAndDeleteSpaceOptions
        space={space}
        isAdmin={isAdmin}
        onInviteMember={onInviteMember}
      />
    </>
  );
};
